import React from 'react'

export const SkeletonCard = () => (
  <div className='sk-card'>
    <div className='sk-poster shimmer' />
    <div className='sk-line shimmer' />
    <div className='sk-line short shimmer' />
  </div>
)

export const SkeletonGrid = ({ count = 12 }) => (
  <div className='movie-grid grid'>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
)

export const SkeletonRow = ({ count = 8 }) => (
  <div className='row-scroller'>
    {Array.from({ length: count }).map((_, i) => (
      <div className='row-item' key={i}>
        <SkeletonCard />
      </div>
    ))}
  </div>
)

export const SkeletonDetails = () => (
  <div className='container detail-card sk-details'>
    <div className='sk-poster-lg shimmer' />
    <div className='sk-info'>
      <div className='sk-tags'>
        <span className='shimmer' />
        <span className='shimmer' />
        <span className='shimmer' />
      </div>
      <div className='sk-title shimmer' />
      <div className='sk-line shimmer' />
      <div className='sk-line shimmer' />
      <div className='sk-line short shimmer' />
      <div className='sk-video shimmer' />
    </div>
  </div>
)
